module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/40.016d998d.png";